
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

// Admin-ruter som kun er tilgjengelige under redigering
const AdminNewsletterPage = lazy(() => import('../pages/admin-nyhetsbrev/page'));

const adminRoutes: RouteObject[] = [
  {
    path: '/admin-nyhetsbrev',
    element: <AdminNewsletterPage />,
  },
];

export default adminRoutes;